import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  Reports,
  ReportsConsulta,
  ReportsOutputs,
  ReportSettings,
  ReportSettingsAdd,
  ReportSettingsEdit,
  ReportsOutputsConsulta,
} from "../../../pages";
import RelatorioProvider from "../../../contexts/RelatorioContext";

const ConfigRoutes = () => {
  return (
    <RelatorioProvider>
      <Routes>
        <Route
          path={":output/configuracoes/:id"}
          element={<ReportSettingsEdit />}
        />
        <Route
          path={":output/configuracoes/add"}
          element={<ReportSettingsAdd />}
        />
        <Route path={":output/configuracoes"} element={<ReportSettings />} />
        <Route
          path={":output/consulta"}
          element={<Navigate replace to={"/reports/enquadramento"} />}
        />
        <Route path={":output/consulta/:id/*"} element={<ReportsConsulta />} />
        <Route path={"enquadramento/*"} element={<ReportsOutputsConsulta />} />
        <Route path={":output/*"} element={<ReportsOutputs />} />
        <Route path={"*"} element={<Reports />} />
      </Routes>
    </RelatorioProvider>
  );
};

export default ConfigRoutes;
